<template>

<DialogBox :settings="settings" :disabled="!isFormValid" @save="save" @show="showingDialog" @hide="hidingDialog">
    <div style="position:relative" class="pr-4 pl-4 pb-4">   
        <v-text-field v-model="field.name" label="Field Name" @change="setIdentifier" />
        <v-text-field v-model="field.identifier" label="Field Identifier" :disabled="Boolean(field._id)" @dblclick="setIdentifier"/>
        <v-select v-model="field.type" :items="fieldTypes" item-text="name" item-value="name" label="Field Type" />
        <v-select v-model="field.control" :items="controlTypes" item-text="name" item-value="name" label="Control Type" />
        <v-text-field v-model="field.options" v-if="field.type == 'List'" label="Options" />
        <v-text-field v-model="field.expression" v-if="field.type == 'Calculated'" label="Expression" />
    </div>
    <div slot="footer">
        <DeleteButton v-if="this.field._id"  @delete="deleteButtonClicked" style="float:left"></DeleteButton>
    </div>
</DialogBox>

</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import MergeHelpers from '../helpers/MergeHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import LookupData from '../helpers/LookupData'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'

import DeleteButton from '../ui-elements/DeleteButton'


import DialogBox from '../ui-elements/DialogBox'
import ContactHelpers from '../helpers/ContactHelpers'


export default {
props:{
    settings: Object,
    field: Object,
},
components:{
    DialogBox,
    DeleteButton,
},
data() {
    return {

    }
},
computed: {

    isFormValid() {
        return true
    },

    fieldTypes() {
        return LookupData.fieldTypes
    },

    controlTypes() {
        return LookupData.controlTypes.filter(o => o.field == this.field.type)
    }

    
},
methods: {

    save() {
        this.$emit('save', this.field)
        this.settings.visible = false
    },


    showingDialog() {
        if(this.field.name && !this.field.identifier)
            this.setIdentifier()
    },

    hidingDialog() {
        setTimeout( () => { 
            
        }, 300)            
    },

    deleteButtonClicked() {
        this.$emit('delete', this.field)
        this.settings.visible = false
    },

    setIdentifier() {
        if(!this.field.identifier && this.field.name)
            this.$set(this.field, 'identifier', StringHelpers.toCamelCase(this.field.name) )
    }

},

created() {
    this.settings.height = '350px'
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// FieldDialog.vue?52b53c52